
$soupmail.control.searchfilter = function($config) {
	
	this.config = {
		selector : 'input.autocomplete',
		model : '',
		listArrayKey : '',
		maxResults : 0,
//		filterColumn : 'email',
		column : { name:'id', cssclass:'id', layout:'' },
		onChange : '',
		onResultsLoaded : '',
		requestDelay : 100,		// minimum delay time (milliseconds) between HTTP requests, so as to not overload the server
		minCharactersRequired : 3,
		defaultSearchboxValue : '',
		dataWrapperElem : '',
		dataRowElem : 'div',
		dataItemRowId : '',
		dataItemRowClass : 'autocomplete-result',
		dataItemElem : 'div'
	};
	
	if ($config) {
		var searchfilter = this;
		jQuery.each($config, function($key, $val) {
			searchfilter.config[$key] = $val;
		});
	}
	
	// the searchfilter control extends off the autocomplete control
	this.prototype = new $soupmail.control.autocomplete(this.config);
	
	this.prototype.load = load;
	this.prototype.render = render;
	this.prototype.size = size;
	this.destroy = destroy;
	
	// this function just proxies the extended prototype
	function destroy() {
		this.prototype.destroy();
	};
	
	// override default load function
	function load($callback) {
		var autocomplete = this;
		var params = {};
		params.max_results = 3;
		params.keywords = this.val();
		$models[this.config.model].getList(params, function($data) {
			autocomplete.items = $data;
			autocomplete.render();
			autocomplete.resultsLoaded();
		});
	};
	
	// override default render function
	function render() {
		
		// render the wrapper and results div
		var html = '';
		var wrapper = '';
		var autocomplete = this;
		if (this.config.dataWrapperElem) {
			wrapper += '<'+this.config.dataWrapperElem+' class="autocomplete_results dashboard-ultrasearch-results">' + "\r\n";
		}
		if (this.config.dataWrapperElem) {
			wrapper += '</'+this.config.dataWrapperElem+'>' + "\r\n";
		}
		if (jQuery(this.config.selector).next('.autocomplete_results').size() == 0) {
			jQuery(this.config.selector).after(wrapper);
		}
		
		// render the necessary html
		if (this.items.emails.length > 0) {
			html += '<h2 class="emails">Emails</h2>';
			jQuery.each(this.items.emails, function($key, $email) {
				html += '<div class="autocomplete-item email-list-item" data-id="'+$email.id+'"><div class="subject"></div><div class="date'+($email.attachments ? ' attachment' : '')+'"></div></div>';
			});
		}
		if (this.items.folders.length > 0) {
			html += '<h2 class="folders">Folders</h2>';
			jQuery.each(this.items.folders, function($key, $folder) {
				html += '<div class="autocomplete-item folder-list-item" data-id="'+$folder.id+'"><div class="num"></div><div class="name"><span class="pipe">|</span><span class="nameVal"></span></div></div>';
			});
		}
		if (this.items.email_addresses.length > 0) {
			html += '<h2 class="people">People</h2>';
			jQuery.each(this.items.email_addresses, function($key, $person) {
				html += '<div class="autocomplete-item person-list-item" data-id="'+$person.id+'"><div class="name"><span class="display_name"></span> <span class="email"></span></div></div>';
			});
		}
		if (this.items.tags.length > 0) {
			html += '<h2 class="tags">Tags</h2><div class="tag-cloud"><ul>';
			jQuery.each(this.items.tags, function($key, $tag) {
				html += '<li class="autocomplete-item" data-id="'+$tag.id+'"><span class="name"></span></li>';
			});
			html += '</ul></div>';
		}
		jQuery(this.config.selector).next('.autocomplete_results').html(html);
		
		// now render the text data for each of the items, and apply event handlers for each item
		jQuery.each(this.items.emails, function($key, $email) {
			if (!$email.subject) { $email.subject = '(no subject)'; }
			var $dateObj = new $soupmail.helpers.SoupMailDate($email.sent_date);
			$emailDOM = jQuery(autocomplete.config.selector).next('.autocomplete_results').find('.email-list-item[data-id="'+$email.id+'"]');
			$emailDOM.find('.subject').text($email.subject);
			$emailDOM.find('.date').text($dateObj.getDashboardDate());
			$emailDOM.click(function() {
				$controllers.main.viewEmail($email.id, $email.subject);
			});
		});
		jQuery.each(this.items.folders, function($key, $folder) {
			$folderDOM = jQuery(autocomplete.config.selector).next('.autocomplete_results').find('.folder-list-item[data-id="'+$folder.id+'"]');
			$folderDOM.find('.num').text($folder.reference);
			$folderDOM.find('.nameVal').text($folder.name);
			$folderDOM.click(function() {
				$folderId_string = '' + $folder.id;
				$controllers.main.display({folder_ids: $folderId_string});
			});
		});
		jQuery.each(this.items.email_addresses, function($key, $person) {
			$personDOM = jQuery(autocomplete.config.selector).next('.autocomplete_results').find('.person-list-item[data-id="'+$person.id+'"]');
			$personDOM.find('.display_name').text($person.display_name);
			$personDOM.find('.email').text('<' + $person.email + '>');
			$personDOM.click(function() {
				$controllers.main.display({person: $person.email});
			});
		});
		jQuery.each(this.items.tags, function($key, $tag) {
			$tagDOM = jQuery(autocomplete.config.selector).next('.autocomplete_results').find('.tag-cloud li[data-id="'+$tag.id+'"]');
			$tagDOM.find('.name').text($tag.name);
			$tagDOM.click(function() {
				$controllers.main.display({tagid: $tag.name});
			});
		});
		
		// finalise the render function
		if (this.size() > 0) {
			this.show();
		} else {
			this.hide();
		}
		$views.all.applyBorder('.dashboard-ultrasearch-results');
		
	};
	
	// override default size function
	function size() {
		return (
			jQuery.objectSize(this.items.emails) +
			jQuery.objectSize(this.items.email_addresses) +
			jQuery.objectSize(this.items.folders) +
			jQuery.objectSize(this.items.tags)
		);
	};
	
	//this.prototype.bind();
	
};



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.control.searchfilter.js